var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-presets"},_vm._l((_vm.presets),function(preset){return _c('div',{key:preset.key,class:['date-presets__item', _vm.active === preset.key && 'date-presets__item--active'],on:{"click":function($event){return _vm.choose(preset)}}},[_vm._v(" "+_vm._s(_vm.$t("datePresets." + preset.key))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }